<template>
  <span>
    <el-form-item label="开始日期：">
      <ybl-select :showSelect="true" :custom="true" v-if="!old">
        <el-date-picker v-model="startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始日期" @focus="beginFocus"
          @change="dateChange" :picker-options="beginPickerOptions" slot="select">
        </el-date-picker>
      </ybl-select>
      <el-date-picker v-model="startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始日期" @focus="beginFocus"
        @change="dateChange" :picker-options="beginPickerOptions" v-else>
      </el-date-picker>
    </el-form-item>
    <el-form-item label="结束日期：">
      <ybl-select :showSelect="true" :custom="true" v-if="!old">
        <el-date-picker v-model="endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择结束日期" @focus="endFocus"
          @change="dateChange" default-time="23:59:59" :picker-options="endPickerOptions" slot="select">
        </el-date-picker>
      </ybl-select>
      <el-date-picker v-model="endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择结束日期" @focus="endFocus" @change="dateChange"
        default-time="23:59:59" :picker-options="endPickerOptions" v-else>
      </el-date-picker>
    </el-form-item>
  </span>
</template>

<script>
import { day } from '@/utils'
export default {
  name: 'yblDateTime',
  model: {
    prop: 'date',
    event: 'change'
  },
  props: {
    date: {
      type: Array,
      default: () => []
    },
    min: {
      type: Number,
      default: () => 0 // 最小日期值（当前日期递推）
    },
    max: {
      type: Number,
      default: () => 0 // 最大日期值（当前日期递推）
    },
    diff: { // 起始日期和截止日期 间隔范围 （单位：天） 默认值 负数 表示不计算
      type: Number,
      default: () => -1
    },
    unit: { // 日期范围单位 （ d 天 M 月 y 年）
      type: String,
      default: () => 'd'
    },
    old: { // 旧版样式
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      startTime: '',
      endTime: '',
      beginPickerOptions: {
        disabledDate (time) {
          return null
        }
      },
      endPickerOptions: {
        disabledDate (time) {
          return null
        }
      }
    }
  },
  created () {
    if (this.date && this.date.length) {
      this.startTime = this.date[0]
      this.endTime = this.date[1]
    }
  },
  methods: {
    getDayDate (value, date, days = 1) { // date 为空时默认当前时间  value值表示多少天
      /* let dateTime = (date && new Date(date)) || new Date()
      return new Date(dateTime.setDate(dateTime.getDate() + value)) */

      const dateTime = day.now(date.substring(0, 10))
      if (this.unit === 'd') {
        return dateTime.add(value, this.unit).$d
      }
      return dateTime.add(value, this.unit).add(days, 'd').$d
    },
    getDiffDate (value, date, days = -1) { // date 为空时默认当前时间  value值 匹配 unit 类型
      const dateTime = day.now(date.substring(0, 10))
      if (this.unit === 'd') {
        return dateTime.add(value, this.unit).$d
      }
      return dateTime.add(value, this.unit).add(days, 'd').$d
    },
    beginFocus () {
      this.beginPickerOptions.disabledDate = (time) => {
        return this.min === 0 ? null : time.getTime() < this.getDayDate(this.min).getTime()
      }
      if (this.endTime) {
        this.beginPickerOptions.disabledDate = (time) => {
          if (this.diff >= 0) {
            return time.getTime() < this.getDayDate(-this.diff, this.endTime).getTime() || time.getTime() >= new Date(this.endTime).getTime()
          }
          return time.getTime() > new Date(this.endTime).getTime()
        }
        if (day.format(this.startTime, 'YYYY-MM-DD') === day.format(this.endTime, 'YYYY-MM-DD')) {
          this.beginPickerOptions.selectableRange = `00:00:00 - ${day.format(this.endTime, 'HH:mm:ss')}`
        }
      }
    },
    endFocus () {
      this.endPickerOptions.disabledDate = (time) => {
        return this.max === 0 ? null : time.getTime() > this.getDayDate(this.max).getTime()
      }
      if (this.startTime) {
        this.endPickerOptions.disabledDate = (time) => {
          if (this.diff >= 0) {
            return time.getTime() < this.getDayDate(0, this.startTime, 0).getTime() || time.getTime() > this.getDiffDate(this.diff, this.startTime).getTime()
          }
          return time.getTime() < this.getDayDate(0, this.startTime).getTime()
        }
        if (day.format(this.startTime, 'YYYY-MM-DD') === day.format(this.endTime, 'YYYY-MM-DD')) {
          this.endPickerOptions.selectableRange = `${day.format(this.startTime, 'HH:mm:ss')} - 23:59:59`
        }
      }
    },
    dateChange (val) {
      if (!this.startTime) {
        this.startTime = val
      }
      if (!this.endTime) {
        this.endTime = val
      }
      let date = [this.startTime, this.endTime]
      if (!val) {
        this.startTime = ''
        this.endTime = ''
        date = []
      }
      this.$emit('change', date)
    }
  },
  watch: {
    'date': function (newVal, oldVal) {
      if (this.date && this.date.length) {
        let date = Array.isArray(this.date) ? this.date : this.date.split(',')
        this.startTime = date[0]
        this.endTime = date[1]
      } else {
        this.startTime = ''
        this.endTime = ''
      }
    }
  }
}
</script>

<style lang="less">
.datetime-range-box {
  display: inline;
}
</style>



// WEBPACK FOOTER //
// src/components/DateTimeRange.vue